import { IoClose } from 'react-icons/io5';
import { FaRegFile } from 'react-icons/fa';
import { useState, useEffect } from 'react';

export enum FileType {
  Image,
  Video,
  Other,
}

interface LightboxProps {
  isOpen: boolean;
  mediaUrl: string;
  type: FileType;
  fileName?: string;
  onClose?: () => any;
}

export const Lightbox = ({ isOpen, mediaUrl, type, fileName = 'File', onClose }: LightboxProps) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    if (onClose) onClose();
  };
  const lightboxContent = () => {
    if (type === FileType.Image) {
      return <img src={mediaUrl} alt={fileName != 'File' ? fileName : 'photo'} />;
    } else if (type === FileType.Video) {
      return <video src={mediaUrl} controls />;
    } else {
      return <FaRegFile />;
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpen(isOpen);
    }, 100);
    return () => clearTimeout(timeout);
  }, [isOpen]);
  return (
    <div className={`lightbox-container${open ? ' open' : ''}`}>
      <div>
        <div className="lightbox-controls">
          <span>{fileName}</span>
          <button className="button transparent" onClick={handleClose}>
            <IoClose />
          </button>
        </div>
        <div className="lightbox-content">{lightboxContent()}</div>
        <div className="lightbox-footer"></div>
      </div>
    </div>
  );
};
